import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UsageRightActivationState } from '@markant-platform/usage-right/model';
import { SharedOrganizationFeatureModule } from '@markant-platform/shared/organization/feature';
import { MarkantElementsModule } from '@markant/elements-angular';
import {
  CartridgeFeatureManagementViewModule,
  ManagementData,
} from '@markant-platform/cartridge/feature-management-view';
import { BookingState } from '@markant-platform/cartridge/model';
import { TranslocoService } from '@jsverse/transloco';
import { OrganizationType } from 'data-model';

@Component({
  selector: 'markant-platform-management-view-demo',
  standalone: true,
  imports: [CommonModule, SharedOrganizationFeatureModule, MarkantElementsModule, CartridgeFeatureManagementViewModule],
  templateUrl: './management-view-demo.component.html',
  styleUrl: './management-view-demo.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ManagementViewDemoComponent {
  @Input() currentStep!: number;

  readonly TRANSLATION_PATH = 'guidedTour.tours.guided-tour-oa-admin-area.section4.step12.calcParam';

  private readonly translocoService = inject(TranslocoService);

  demoService: ManagementData = {
    id: 'abc',
    usageRightActivationState: UsageRightActivationState.ACTIVE,
    cartridgeVariantName: 'm.RawMaterialMonitor',
    price: {
      currency: 'EUR',
      centAmount: 345500,
      priceModel: 'SUBSCRIPTION',
      billingPeriod: 'MONTHLY',
      targetAudience: {
        organizationType: OrganizationType.DEALER,
        ezr: false,
      },
    },
    setUpCost: {
      currency: 'EUR',
      centAmount: 100000,
    },
    calculationParameters: [1, 2, 3, 4, 5].map(number =>
      this.translocoService.translate(`${this.TRANSLATION_PATH}${number}`)
    ),
    bookingState: BookingState.BOOKED,
    bookingDate: new Date('2023-01-29'),
    workflowFinishedAt: new Date('2023-02-02'),
    bookingStartedAt: new Date('2023-02-04'),
    organizationId: '',
    singleVariant: false,
    cartridgeVariantId: '1234e29544e9fd436c21abcd',
    cartridgeId: '',
    priceRequestId: '',
    serviceManager: 'Max Mustermann',
    serviceManagerId: 'abc',
    blocked: false,
    serviceUpgradeState: null,
  };
}
